import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';

/**
 * Componente que exibe os requisitos de senha em tempo real
 * Mostra cada requisito com ícone de check (verde) ou X (vermelho)
 */
export default function PasswordRequirements({ requirements, allMet }) {
  if (!requirements || requirements.length === 0) return null;

  return (
    <div className="mt-3 space-y-2">
      <p className="text-sm font-medium text-slate-700">
        Requisitos da senha:
      </p>
      <div className="space-y-1.5">
        {requirements.map((req) => (
          <div
            key={req.id}
            className={`flex items-center gap-2 text-sm transition-all duration-200 ${
              req.met ? 'text-green-600' : 'text-slate-500'
            }`}
          >
            {req.met ? (
              <CheckCircle className="w-4 h-4 flex-shrink-0" />
            ) : (
              <XCircle className="w-4 h-4 flex-shrink-0" />
            )}
            <span className={req.met ? 'line-through' : ''}>{req.label}</span>
          </div>
        ))}
      </div>
      
      {allMet && (
        <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg flex items-center gap-2">
          <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" />
          <p className="text-sm font-medium text-green-800">
            Senha forte! Todos os requisitos foram atendidos.
          </p>
        </div>
      )}
    </div>
  );
}
